<script setup>
defineProps({
  detailData: {
    type: Object,
    required: true
  }
})
const toggleList = [
  { text: '10分ごと', key: '10m' },
  { text: '1時間ごと', key: '1h' }
]
const type = ref('10m')
</script>

<template>
  <section class="riverWaterLevel">
    <RiverWaterLevelGraph
      :data="detailData"
      :type="type"
    />
    <CommonToggle
      v-model:selected="type"
      :list="toggleList"
      form="square"
      type="noBorder"
    />
    <RiverWaterLevelChart
      :data="detailData"
      :type="type"
    />
    <div class="hanrei">
      <p>※データ提供：国土交通省および都道府県</p>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.riverWaterLevel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .hanrei{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    p {
      color: #303030;
      font-size: 12px;
      font-weight: 300;
      line-height: 1em;
    }
  }
}
</style>
